import { useCallback } from "react";
import { db } from "../Services/firebase-config";
import {
  doc,
  collection,
  deleteDoc,
  updateDoc,
  getDocs,
  setDoc,
} from "firebase/firestore";

export const useNotes = () => {
  const randomId = () => {
    return Math.random() * 1000;
  };

  const getNotes = useCallback(async (dbId) => {
    if (dbId) {
      let notes = [];
      const collectionRef = collection(db, "users", dbId, "notes");
      const data = await getDocs(collectionRef);
      data.docs.forEach((doc) => {
        notes.push({ ...doc.data(), id: doc.id });
      });
      return notes;
    }
  }, []);

  const addNote = useCallback(async (dbId, noteData) => {
    await setDoc(doc(db, "users", dbId, "notes", `$${dbId}_${randomId()}`), {
      title: noteData.title,
      text: noteData.text,
      id: `$${dbId}_${randomId()}`,
    });
  }, []);

  const updateNote = useCallback(async (dbId, newNoteData, oldNoteData) => {
    await updateDoc(doc(db, "users", dbId, "notes", oldNoteData.noteId), {
      title: newNoteData.title,
      text: newNoteData.text,
    });
  }, []);

  const deleteNote = useCallback(async (dbId, noteID) => {
    await deleteDoc(doc(db, "users", dbId, "notes", noteID));
  }, []);

  return { getNotes, addNote, updateNote, deleteNote };
};
